import YTreeOrg from './src'

YTreeOrg.install = Vue => {
  Vue.component(YTreeOrg.name, YTreeOrg)
}

export default YTreeOrg
